

export const URL = process.env.NODE_ENV === 'dev' ? '/' : 'http://zgh5.tjaiyou.net/'
